import add from './add.vue'
const commonAddHeader = {
    install:function(Vue) {
        Vue.component('common-add-header', add)
    }
}
// 导出该组件
export default commonAddHeader